import { makePostRequest } from 'owa-ows-gateway';
import { AlchemyInsightsRequest } from '../schema/AlchemyInsightsRequest';
import { AlchemyInsightsResponse } from '../schema/AlchemyInsightsResponse';
const GET_ALCHEMY_INSIGHTS_URL: string = 'ows/api/beta/alchemy/insights';

export default function fetchAlchemyInsights(
    insightsRequest: AlchemyInsightsRequest
): Promise<AlchemyInsightsResponse> {
    return makePostRequest(GET_ALCHEMY_INSIGHTS_URL, insightsRequest);
}
